module.exports = __webpack_public_path__ + "static/img/LANCASTER_OAK.07067af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/LANCASTER_OAK.jpg
// module id = UXyc
// module chunks = 0